<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
._btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 7px 12px;
}

._btn {
    margin: 0 !important;
    line-height: 1;
    color:#fff;
}
.staff-service-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 85px;
}

.staff-info {
    min-width: 0;
    padding-right: 12px;
}

.staff-info h6 {
    margin: 0 0 5px;
    font-size: 15px;
    font-weight: 600;
    color: #343a40;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.staff-info span {
    font-size: 12px;
    color: #6c757d;
}

/* Service counter */

.staff-services {
    width: 58px;
    height: 58px;
    border-radius: 50%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
    color: #fff;
}

.staff-services strong {
    font-size: 17px;
    font-weight: 700;
    line-height: 18px;
}

.staff-services small {
    font-size: 8px;
    text-transform: uppercase;
    line-height: 10px;
}


/* Success */

.success-card {
    border-left: 3px solid #198754;
}

.success-card .staff-services {
    background: #198754;
}


/* Primary */

.primary-card {
    border-left: 3px solid #0d6efd;
}

.primary-card .staff-services {
    background: #0d6efd;
}


/* Warning */

.warning-card {
    border-left: 3px solid #ffc107;
}

.warning-card .staff-services {
    background: #ffc107;
    color: #212529;
}


/* Danger */

.danger-card {
    border-left: 3px solid #dc3545;
}

.danger-card .staff-services {
    background: #dc3545;
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                    <h3 class="font-weight-bold">Customer Service Team</h3>
                    <span></span>
                   </div>
                </div>
            </div>
        </div>

      <div class="row">

    <!-- Success -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card success-card">

            <div class="staff-info">
                <h6>{{ dataz.best_day.fulname }}</h6>
                <span>{{ dataz.best_day.username }}</span>
                <p class="text-success">Best of Today</p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.best_day.servs }}</strong>
                <small>Services</small>
            </div>

        </div>
    </div>

    <!-- Primary -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card primary-card">

            <div class="staff-info">
                <h6>{{ dataz.best_week.fulname }}</h6>
                <span>{{ dataz.best_week.username }}</span>
                <p class="text-primary">Best of Weak</p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.best_week.servs }}</strong>
                <small>Services</small>
            </div>

        </div>
    </div>

    <!-- Warning -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card warning-card">

            <div class="staff-info">
               <h6>{{ dataz.low_day.fulname }}</h6>
                <span>{{ dataz.low_day.username }}</span>
                <p class="text-warning">Low of Today</p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.low_day.servs }}</strong>
                <small>Services</small>
            </div>

        </div>
    </div>

    <!-- Danger -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card danger-card">

            <div class="staff-info">
              <h6>{{ dataz.low_week.fulname }}</h6>
                <span>{{ dataz.low_week.username }}</span>
                <p class="text-danger">Low of Weak</p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.low_week.servs }}</strong>
                <small>Services</small>
            </div>

        </div>
    </div>

</div>

        <div class="row">
            <div class="col-12">
                    
                    <div class="row mb-3">
                        <div class="col-sm-6 col-md-3 col-12 stretch-card col-grid">
<input type="text" v-model="this.search_staff"
                                                class="form-control"
                                                placeholder="Search to filter">
                        </div>
                        
                           <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid"></div>
                           <div v-if="user.role == 4" class="col-sm-12 col-md-6 col-12 stretch-card col-grid"></div>
                    <div  v-if="user.role < 4" class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div  v-if="user.role < 4" class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    
                  
                    <div  v-if="user.role < 4" class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterStaffs" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                         
                    </div>
                  
                    <div class="row">
                        <div class="col-12">
                            <h4 class="my-3 text-center">{{heading}}</h4>
                              <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                            <div class="table-responsive">
                                
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                             <th>No</th>
                                            <th> User name </th>
                                            <th> Full name </th>
                                            <th> Phone no </th>
                                            <th> Home Branch </th>
                                            <th> Serv's </th>
                                            <th> Branch's </th>
                                            <th  v-if="user.role < 4"> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody id="staff-list">

                                        <tr v-for="(staff, index) in paginatedStaffs" :key="staff.id"  id="staff_{{this.id}}">
                                             <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                            <td> {{staff.username}} </td>
                                            <td class="text-capitalize"> {{staff.fulname}}</td>
                                            <td>
                                                {{staff.phone1}}
                                            </td>
                                            <td> {{staff.bname}}</td>
                                             <td class="text-center">
                                                <b>{{ staff.servs }}</b>
                                            </td>
                                            <td class="text-center">
                                                <b>{{ staff.branches }}</b>
                                            </td>
                                            <td  v-if="user.role < 4">
                                                <!--router-link
                                                    :to="{
                                                        name: 'service-add-branch',
                                                        params: { id: user.id }
                                                    }" class="_btn btn btn-primary btn-icon">
                                                    <i class="fa fa-plus"></i>
                                                </router-link-->
                                                <span class="m-1"></span>
                                                <router-link
                                                    :to="{
                                                        name: 'service-individual',
                                                        params: { id: staff.id }
                                                    }" class="_btn btn btn-primary">
                                                      Details
                                                </router-link>
                                             
                                            </td>
                                        </tr>
                                     
                                    </tbody>
                                </table>
                            </div>
                                                       <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
                        </div>
                    </div>
               
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            search_staff:"",
            heading:"To days Customer's Service Team Reports",
            staffs:[],
            og_staffs:[],
            dataz:{
                best_day:{},
                best_week:{},
                low_day:{},
                low_week:{},
            },
            fdate:"",
            tdate:"",
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

        async getStaffs() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/service/all-staffs")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false
                this.staffs = response.data.staffs;
                this.og_staffs = response.data.staffs
                this.dataz = response.data.dataz

               /// console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

          async filterStaffs(){

             this.loading = true
          var fdate = this.fdate
          var tdate = this.tdate

          var response = await axios
              .post(this.$store.state.api_url + "/service/filter-all-staffs", {fdate, tdate})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.staffs = response.data.staffs;
                this.og_staffs = response.data.staffs
               
                this.heading = "Services Reports From ("+fdate+" To "+tdate+")"
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedStaffs() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.staffs.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.staffs.length / this.perPage)
  },
  

},
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) ||
                    (branch.region && branch.region.toLowerCase().includes(term))
                )
            })
        },


        search_staff(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.staffs = this.og_staffs
                return
            }

            this.staffs = this.og_staffs.filter(staff => {

                return (
                    (staff.bname && staff.bname.toLowerCase().includes(term)) ||
                    (staff.bregion && staff.bregion.toLowerCase().includes(term)) ||
                    (staff.username && staff.username.toLowerCase().includes(term)) ||
                    (staff.fulname && staff.fulname.toLowerCase().includes(term)) ||
                    (staff.phone1 && staff.phone1.toLowerCase().includes(term))
                )
            })
        }
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getStaffs()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
